/* eslint-disable no-undef */
/* eslint-disable no-unused-expressions */
import { attachCountryChangeHandler, addLocation, areasTelephone } from './companyLocation';
import { pills } from './pills';
import addInputHiddenWithEmptyValue from './addInputHiddenWithEmptyValue';
import { continentsCountries, expertises } from './listItems';
import { initialUpdateDropdownListItems } from './handleDropdownList'
import { dropToUploadFile } from '../utils/dragAndDropUploads'
import { switchProjectTabs, addAndEditCollabValidations } from './project';
import DOMReady from '../utils/DomReady';
import {toggleMobileSideBar} from '../utils/common'

// ABOUT CHARACTERS COUNTER
const aboutCharacterCounter = () => {
  const aboutTextareas = document.querySelectorAll('.js-about-textarea');

  const characterCounter = textArea => {
    const aboutCharacterNumber = textArea.parentNode.querySelector('.js-character');
    const aboutTextareaLength = textArea.value.length
    aboutCharacterNumber.innerHTML = `${aboutTextareaLength}/${textArea.getAttribute('maxlength')}`;
  };
  aboutTextareas && aboutTextareas.forEach( textArea => {
    characterCounter(textArea)
    textArea.addEventListener('keyup', () => {
      characterCounter(textArea)
    });
  })
  
};

// TRIGGER SUBMIT FORM
const sendFormData = () => {
  const cta = document.querySelector('.js-profile-cta');
  const expertForm = document.querySelector('.js-expert-profile-form');
  const nonActiveCountryRadio = document.querySelector('#activity-no');
  const areasPillsContainers = document.querySelector('#js-pills-area-container');
  const submitForm = () => expertForm.submit();

  cta.addEventListener('click', () => {
    if (nonActiveCountryRadio && nonActiveCountryRadio.checked) {
      areasPillsContainers.innerHTML = '';
      addInputHiddenWithEmptyValue(submitForm, areasPillsContainers);
    } else {
      submitForm();
    }
  });
};

// TOOGLE RADIO BUTTONS FOR ACTIVITY AREAS 
const toggleActivityAreas = () => {
  const radioButtons = document.querySelectorAll('.afd-radio__input');
  const countryContainer = document.querySelector('#activity-countries');

  radioButtons.forEach( radio => {
    radio.addEventListener('change', () => countryContainer.classList.toggle('afd-hide'));
  });
};


// GET EXPERTISES
const getExpertises = cb => {
  const selectExpertise = document.querySelector('#expert_profile_expert_categories')
  if (!selectExpertise) return;
  
  for ( let i = 0; i < selectExpertise.options.length; i++ ) {
    let expertiseItem = { type: 'expertise'}
    expertiseItem.name = selectExpertise.options[i].value
    expertises.push(expertiseItem)
  }
  // this Callback is running after getting all the expertises from the selectbox.
  // Then we can handle the items and remove from this list the preselected expertises.
  cb && cb(expertises)
}

/**
 * Actions to perform on document ready.
 */
DOMReady(() => { 
  const submitForm = document.querySelector('.js-edit-project-form')
  if (window.location.href.includes('/profiles')) {
    toggleMobileSideBar()  
    if (!window.location.href.includes('/projects')) dropToUploadFile()
    
    if (document.querySelector('.js-expert-profile-form') !== null) {
      // Logic for handling loading cities when the user selects a country
      const countrySelector = document.querySelector('.js-expert-profile__country');
      attachCountryChangeHandler(countrySelector);

      // Logic for adding new locations
      const addLocationBtn = document.querySelector('.js-expert-profile__btn--add-location');
      addLocationBtn && addLocationBtn.addEventListener('click', addLocation);
    
      document.querySelectorAll('.phone-suggestor').forEach(el => areasTelephone(el));
      aboutCharacterCounter()
      pills()
      toggleActivityAreas()
      sendFormData()
      initialUpdateDropdownListItems(continentsCountries)
      getExpertises(initialUpdateDropdownListItems)
    }
    //dropToUploadFile()
    switchProjectTabs()
    addAndEditCollabValidations()
    aboutCharacterCounter()
  }

});